import React from "react"
import { OrderLineModificationDeleteData } from "lib/types/generated/graphql-types"
import { Id, Name, ProductImage, Row, Status } from "../../Shared.styled"
import { handleImageError } from "helpers/image"

type Props = {
  orderLine: OrderLineModificationDeleteData
}

export const VariantRowDeleted = ({ orderLine }: Props) => {
  return (
    <Row key={orderLine.id}>
      <ProductImage src={orderLine?.imageUrl as string} onError={handleImageError} />
      <div>
        <Status $deleted={true}>Deleted</Status>
        <Name>{orderLine?.name}</Name>
        <div>Order quantity: {orderLine.quantity}</div>
        <Id>
          <b>Variant ID:</b> <span>{orderLine?.productVariantId}</span>
        </Id>
      </div>
    </Row>
  )
}
